import { cn } from "@/utils/cn";

interface LinearProgressBarProps {
  value: number;
  max?: number;
  className?: string;
  "aria-label"?: string;
}

const LinearProgressBar = ({
  value,
  max = 1,
  className,
  "aria-label": ariaLabel,
}: LinearProgressBarProps) => {
  return (
    <progress
      aria-label={ariaLabel}
      className={cn(
        "h-1 rounded-full overflow-hidden bg-progress-bar-active accent-progress-bar-active",
        "[&::-webkit-progress-bar]:bg-progress-bar-inactive",
        "[&::-webkit-progress-value]:bg-progress-bar-active",
        "[&::-moz-progress-bar]:bg-progress-bar-active",
        className,
      )}
      value={value}
      max={max}
    />
  );
};

export default LinearProgressBar;
